export default __webpack_public_path__ + "static/media/depenses.b7b60334.svg";